exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p3-expiry-card{color:transparent;caret-color:#333}.p3-mask{position:absolute;left:13px;right:13px;top:7px;bottom:7px;color:#ccc;pointer-events:none}.p3-mask span{color:#333}", ""]);

// exports
